import { useAtom } from 'jotai';
import { addToastAtom } from '../toastsStore.atoms';

function useAddToast() {
	const [, addToast] = useAtom(addToastAtom);

	return { addToast };
}

export default useAddToast;
